export default {
    computed: {
        devMode() {
            return process.env.VUE_APP_DEV_MODE == 'true' ? true : false
        }
    },

    methods: {
        touchActionNone() {
            let allElement = document.getElementsByTagName("*")
            for (let i of allElement) {
                i.style.touchAction = "none"
            }
        },

        removeTouchActionNone() {
            let allElement = document.getElementsByTagName("*")
            for (let i of allElement) {
                i.style.touchAction = 'auto'
            }
        },

        translate(key, variables) {
            if (!this.$i18n && typeof this.$i18n == 'undefined') {
                return window.translate(key, variables)
            }

            return this.$t(key, variables)
        },

        firstUppercase(key) {
            return key.charAt(0).toUpperCase() + key.slice(1)
        },

        randomPlaceholderImage() {
            let imageArr = []

            for (let i = 1; i <= 4; i++) {
                imageArr.push(`no-image${i}.png`)
            }

            return imageArr[Math.floor(Math.random() * imageArr.length)];
        },

        getQuizImage(quiz, flag) {
            let image
            const baseUrl = process.env.VUE_APP_API_BASE_URL.replace('/api', '')

            if (flag && typeof flag != "undefined") {
                if (quiz.image && typeof quiz.image != "undefined" && quiz.image != "") {
                    image = quiz.image
                } else if (quiz.image_placeholder && typeof quiz.image_placeholder != "undefined" && quiz.image_placeholder != "") {
                    image = `${baseUrl}images/${quiz.image_placeholder}`
                } else { // fixed quiz image wrap on question.vue
                    image = `${baseUrl}images/no-image2.png`
                }
            }

            return image
        },

        fitStageIntoParentContainer(size) {
            if (this.$refs.stage) {
                const sceneWidth = size.width
                const sceneHeight = size.height

                // now we need to fit stage into parent container
                const containerWidth = this.$refs.stage.getNode().getContainer().offsetWidth
                // but we also make the full scene visible
                // so we need to scale all objects on canvas
                const scale = containerWidth / sceneWidth

                this.$refs.stage.getNode().width(sceneWidth * scale)
                this.$refs.stage.getNode().height(sceneHeight * scale)
                this.$refs.stage.getNode().scale({ x: scale, y: scale })
            }
        },

        handleMute(audio, val) {
            const soundVolume = audio.id == 'audioBgSrc' ? this.quiz.background_music.volume : 1
            if (val) {
                //Mute music
                let vol = soundVolume
                const decrease = vol / 5
                const fadeMusic = setInterval(() => {
                    if (vol.toFixed(1) > 0) {
                        vol -= decrease
                        audio.volume = vol.toFixed(1)
                    } else {
                        audio.volume = 0
                        audio.pause()
                        clearInterval(fadeMusic)
                    }
                }, 100)
            } else {
                //Unmute Music
                if (audio.paused) {
                    audio.play()
                }

                if (audio.volume >= 1) return

                let vol = 0
                const increase = soundVolume / 5
                const fadeMusic = setInterval(() => {
                    if (vol.toFixed(1) < soundVolume) {
                        vol += increase
                        if (vol < soundVolume) {
                            audio.volume = vol.toFixed(1)
                        }
                    } else {
                        audio.volume = soundVolume
                        clearInterval(fadeMusic)
                    }
                }, 100)
            }
        },

        stripHtmlTag(message) {
            return message.replace(/<[^>]*>?/gm, ' ');
        },

        checkQuestionTypeName(val) {
            if (val == 'typing_question') {
                return 'Typing Question'
            }

            if (val == 'sorting_list') {
                return 'Sorting List'
            }

            if (val == 'scale_image') {
                return 'Scale Image'
            }

            if (val == 'reveal_image') {
                return 'Reveal Image'
            }

            return val
        },

        renderHotspotImage(image) {
            return new Promise(resolve => {
                const canvasImgElement = document.createElement('img')
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const imgWidth = image.width
                const imgHeight = image.height

                // Set default canvas size
                canvas.width = imgWidth
                canvas.height = imgHeight

                // Set custom canvas size
                if (imgWidth > imgHeight) {
                    canvas.width = imgHeight
                    canvas.height = imgHeight
                }

                if (imgWidth < imgHeight) {
                    canvas.width = imgWidth
                    canvas.height = imgWidth
                }

                const posX = canvas.width / 2 - imgWidth / 2
                const posY = canvas.height / 2 - imgHeight / 2

                ctx.drawImage(image, posX, posY, imgWidth, imgHeight)

                canvasImgElement.src = canvas.toDataURL()

                canvasImgElement.onload = () => {
                    resolve(canvasImgElement)
                }
            })
        },

        retry(cb, time) {
            let timer = null
            let counter = 0
            timer = setInterval(() => {
                if (counter >= time) {
                    clearInterval(timer)
                }

                typeof cb === 'function' && cb()
                counter++
            }, 100)
        },

        addStyleSheet(code) {
            const link = document.createElement('link')
            link.setAttribute(
                'href',
                `${process.env.VUE_APP_ROOT_URL}style/dynamic/quiz/${code}.css?rand=${new Date().getTime()}`
            )

            link.setAttribute('rel', 'stylesheet')
            link.setAttribute('type', 'text/css')
            link.setAttribute('id', 'dynamic-css')
            document.head.appendChild(link)
        },

        addStyleSheetSystem() {
            const link = document.createElement('link')
            link.setAttribute(
                'href',
                `${process.env.VUE_APP_ROOT_URL}style/dynamic/static.css?rand=${new Date().getTime()}`
            )

            link.setAttribute('rel', 'stylesheet')
            link.setAttribute('type', 'text/css')
            link.setAttribute('id', 'static-css')
            document.head.appendChild(link)
        },

        moneyNokFormat(amount) {
            return new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
        },

        moneyUsdFormat(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
        },

        validateEmail(email) {
            const emailRegex =
                // eslint-disable-next-line no-control-regex
                /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i

            if (!emailRegex.test(email)) {
                return false
            }

            const [localPart, domain] = email.split('@')

            if (email.length > 254 || localPart.length > 64 || domain.length > 255) {
                return false
            }

            if (/\.{2,}/.test(localPart)) {
                return false
            }

            const tld = domain.split('.').pop()
            if (!/^[a-z]{2,}$/i.test(tld)) {
                return false
            }

            return true
        },

        slugify(text) {
            return text
                .toString()
                .normalize('NFD')
                .toLowerCase()
                .trim()
                .replace(/[`~!@#$%฿^&*()_\-+=[\]{};:'"\\|/,.<>?\s]/g, '-')
                .replace(/[\s_-]+/g, '-')
                .replace(/--+/g, '-')
                .replace(/^-|-$/g, '')
        },

        isValidSlug(slug) {
            const slugPattern = /^(?!-)([a-z0-9]+(-[a-z0-9]+)*)?$/;
            return slugPattern.test(slug);
        }
    }
}
